<div style="overflow-y: auto; height: calc(100vh - 8.563rem);">
    <div style="text-align: center">
        <span style="font-size: 1.688rem; color: #4c4c4c">Manage Assignments and Contacts</span>
    </div>
    <div>
        <span class="projectScopeHeader">Form Owner</span>
    </div>
    <div style="margin-top: 0.688rem;">
        <div
          style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd; position: relative;"
        >
          <mat-form-field
            *ngIf="!(formOwner && formOwner.mail)"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="formOwnerField"
              type="text"
              placeholder="Form Owner (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto1"
              [formControl]="formOwnerControl"
              [(ngModel)]="formOwner"
              required
              (keydown.enter)="searchUsersFormOwner($event.target.value)"
            />
          </mat-form-field>
          <mat-form-field
            *ngIf="formOwner && formOwner.mail"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="formOwnerField"
              type="text"
              placeholder="Form Owner (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto1"
              [formControl]="formOwnerControl"
              [(ngModel)]="formOwner"
              readonly="true"
            />
          </mat-form-field>
          <mat-autocomplete
            #auto1="matAutocomplete"
            [displayWith]="displayFnFormOwner"
          >
            <mat-option
              *ngFor="let option of formOwnerOptions"
              style="color: #696969"
              [value]="option"
            >
              <span
                *ngIf="option.givenName && option.surname && option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="option.givenName && option.surname && !option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}})</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && option.jobTitle"
                >{{option.displayName}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && !option.jobTitle"
                >{{option.displayName}} ({{option.mail}})</span
              >
            </mat-option>
          </mat-autocomplete>
          <div
            *ngIf="formOwner && formOwner.mail"
            style="display: inline-block; padding-top: 1.813rem; z-index: 0; position: absolute;"
          >
            <img
              (click)="deleteFormOwner()"
              style="margin-left: -1.5rem; cursor: pointer"
              src="assets/close-window.svg"
            />
          </div>
          <div style="display: inline-block; margin-left: 0.938rem;">
            <button
              class="confirmButton"
              type="button"
              style="width: 5rem"
              (click)="searchUsersFormOwner(formOwner)"
            >
              <span class="confirmText">SEARCH</span>
            </button>
          </div>
        </div>
      </div>
      <div>
        <span class="projectScopeHeader">ITPAC Assignment</span>
    </div>
    <div style="margin-top: 0.688rem;">
        <div
          style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd; position: relative;"
        >
          <mat-form-field
            *ngIf="!(etsPacAssignment && etsPacAssignment.mail)"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="etsPacAssignmentField"
              type="text"
              placeholder="ITPAC Assignment (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto2"
              [formControl]="etsPacAssignmentControl"
              [(ngModel)]="etsPacAssignment"
              required
              (keydown.enter)="searchUsersEtsPacAssignment($event.target.value)"
            />
          </mat-form-field>
          <mat-form-field
            *ngIf="etsPacAssignment && etsPacAssignment.mail"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="etsPacAssignmentField"
              type="text"
              placeholder="ITPAC Assignment (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto2"
              [formControl]="etsPacAssignmentControl"
              [(ngModel)]="etsPacAssignment"
              readonly="true"
            />
          </mat-form-field>
          <mat-autocomplete
            #auto2="matAutocomplete"
            [displayWith]="displayFnEtsPacAssignment"
          >
            <mat-option
              *ngFor="let option of etsPacAssignmentOptions"
              style="color: #696969"
              [value]="option"
            >
              <span
                *ngIf="option.givenName && option.surname && option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="option.givenName && option.surname && !option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}})</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && option.jobTitle"
                >{{option.displayName}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && !option.jobTitle"
                >{{option.displayName}} ({{option.mail}})</span
              >
            </mat-option>
          </mat-autocomplete>
          <div
            *ngIf="etsPacAssignment && etsPacAssignment.mail"
            style="display: inline-block; padding-top: 1.813rem; z-index: 0; position: absolute;"
          >
            <img
              (click)="deleteEtsPacAssignment()"
              style="margin-left: -1.5rem; cursor: pointer"
              src="assets/close-window.svg"
            />
          </div>
          <div style="display: inline-block; margin-left: 0.938rem;">
            <button
              class="confirmButton"
              type="button"
              style="width: 5rem"
              (click)="searchUsersEtsPacAssignment(etsPacAssignment)"
            >
              <span class="confirmText">SEARCH</span>
            </button>
          </div>
        </div>
      </div>
      <div>
        <span class="projectScopeHeader">Current Assignment</span>
    </div>
    <div style="margin-top: 0.688rem;">
        <div
          style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd; position: relative;"
        >
          <mat-form-field
            *ngIf="!(currentAssignment && currentAssignment.mail)"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="currentAssignmentField"
              type="text"
              placeholder="Current Assignment (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto3"
              [formControl]="currentAssignmentControl"
              [(ngModel)]="currentAssignment"
              required
              (keydown.enter)="searchUsersCurrentAssignment($event.target.value)"
            />
          </mat-form-field>
          <mat-form-field
            *ngIf="currentAssignment && currentAssignment.mail"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="currentAssignmentField"
              type="text"
              placeholder="Current Assignment (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto3"
              [formControl]="currentAssignmentControl"
              [(ngModel)]="currentAssignment"
              readonly="true"
            />
          </mat-form-field>
          <mat-autocomplete
            #auto3="matAutocomplete"
            [displayWith]="displayFnCurrentAssignment"
          >
            <mat-option
              *ngFor="let option of currentAssignmentOptions"
              style="color: #696969"
              [value]="option"
            >
              <span
                *ngIf="option.givenName && option.surname && option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="option.givenName && option.surname && !option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}})</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && option.jobTitle"
                >{{option.displayName}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && !option.jobTitle"
                >{{option.displayName}} ({{option.mail}})</span
              >
            </mat-option>
          </mat-autocomplete>
          <div
            *ngIf="currentAssignment && currentAssignment.mail"
            style="display: inline-block; padding-top: 1.813rem; z-index: 0; position: absolute;"
          >
            <img
              (click)="deleteCurrentAssignment()"
              style="margin-left: -1.5rem; cursor: pointer"
              src="assets/close-window.svg"
            />
          </div>
          <div style="display: inline-block; margin-left: 0.938rem;">
            <button
              class="confirmButton"
              type="button"
              style="width: 5rem"
              (click)="searchUsersCurrentAssignment(currentAssignment)"
            >
              <span class="confirmText">SEARCH</span>
            </button>
          </div>
        </div>
      </div>
      <div>
        <span class="projectScopeHeader">Form Contacts</span>
    </div>
    <div style="margin-top: 0.688rem;">
        <div
          style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd; position: relative;"
        >
          <mat-form-field
            *ngIf="!(primaryContact && primaryContact.mail)"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="primaryContactField"
              type="text"
              placeholder="Primary Contact (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto4"
              [formControl]="primaryContactControl"
              [(ngModel)]="primaryContact"
              required
              (keydown.enter)="searchUsersPrimaryContact($event.target.value)"
            />
          </mat-form-field>
          <mat-form-field
            *ngIf="primaryContact && primaryContact.mail"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="primaryContactField"
              type="text"
              placeholder="Primary Contact (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto4"
              [formControl]="primaryContactControl"
              [(ngModel)]="primaryContact"
              readonly="true"
            />
          </mat-form-field>
          <mat-autocomplete
            #auto4="matAutocomplete"
            [displayWith]="displayFnPrimaryContact"
          >
            <mat-option
              *ngFor="let option of primaryContactOptions"
              style="color: #696969"
              [value]="option"
            >
              <span
                *ngIf="option.givenName && option.surname && option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="option.givenName && option.surname && !option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}})</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && option.jobTitle"
                >{{option.displayName}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && !option.jobTitle"
                >{{option.displayName}} ({{option.mail}})</span
              >
            </mat-option>
          </mat-autocomplete>
          <div
            *ngIf="primaryContact && primaryContact.mail"
            style="display: inline-block; padding-top: 1.813rem; z-index: 0; position: absolute;"
          >
            <img
              (click)="deletePrimaryContact()"
              style="margin-left: -1.5rem; cursor: pointer"
              src="assets/close-window.svg"
            />
          </div>
          <div style="display: inline-block; margin-left: 0.938rem;">
            <button
              class="confirmButton"
              type="button"
              style="width: 5rem"
              (click)="searchUsersPrimaryContact(primaryContact)"
            >
              <span class="confirmText">SEARCH</span>
            </button>
          </div>
        </div>
      </div>
      <div style="margin-top: 0.688rem;">
        <div
          style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd; position: relative;"
        >
          <mat-form-field
            *ngIf="!(itSponsor && itSponsor.mail)"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="itSponsorField"
              type="text"
              placeholder="Sponsor (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto5"
              [formControl]="itSponsorControl"
              [(ngModel)]="itSponsor"
              required
              (keydown.enter)="searchUsersItSponsor($event.target.value)"
            />
          </mat-form-field>
          <mat-form-field
            *ngIf="itSponsor && itSponsor.mail"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="itSponsorField"
              type="text"
              placeholder="IT Sponsor (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto5"
              [formControl]="itSponsorControl"
              [(ngModel)]="itSponsor"
              readonly="true"
            />
          </mat-form-field>
          <mat-autocomplete
            #auto5="matAutocomplete"
            [displayWith]="displayFnItSponsor"
          >
            <mat-option
              *ngFor="let option of itSponsorOptions"
              style="color: #696969"
              [value]="option"
            >
              <span
                *ngIf="option.givenName && option.surname && option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="option.givenName && option.surname && !option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}})</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && option.jobTitle"
                >{{option.displayName}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && !option.jobTitle"
                >{{option.displayName}} ({{option.mail}})</span
              >
            </mat-option>
          </mat-autocomplete>
          <div
            *ngIf="itSponsor && itSponsor.mail"
            style="display: inline-block; padding-top: 1.813rem; z-index: 0; position: absolute;"
          >
            <img
              (click)="deleteItSponsor()"
              style="margin-left: -1.5rem; cursor: pointer"
              src="assets/close-window.svg"
            />
          </div>
          <div style="display: inline-block; margin-left: 0.938rem;">
            <button
              class="confirmButton"
              type="button"
              style="width: 5rem"
              (click)="searchUsersItSponsor(itSponsor)"
            >
              <span class="confirmText">SEARCH</span>
            </button>
          </div>
        </div>
      </div>
      <div style="text-align: center">
      <div style="display: inline-block; margin-top: 2.625rem; margin-right: 0.875rem;">
        <div class="exitButton" (click)="closeDialog()">
          <span class="exitText">CANCEL</span>
        </div>
    </div>
      <div style="display: inline-block; margin-top: 2.625rem;">
        <button class="confirmButton" (click)="saveAndClose()">
            <span class="confirmText">SAVE CHANGES</span>
        </button>
    </div>
    <div>
</div>